import { showToast } from '@/utils/showToast';

export const globalProperties = {
  $showToast: showToast,
};
